import { MovementListPage } from './MovementListPage.js';

/**
 * UI_REFERENCE_SOURCE:
 * section: Sakhtar Inventory.dc.html §03 GOODS ISSUE
 * archetype: ENTITY_LIST + create form
 * status: KIT_CONFORMANT — real create form (`POST .../inventory/issues`,
 *   real `inventory.issue.create` permission). A live "قابل استفاده" hint
 *   per line (from the real, already-fetched stock balances) matches the
 *   board's own rule: no override/force-post option exists, only the
 *   path of correcting the quantity — a negative-stock attempt is
 *   rejected server-side and the real message is shown.
 * state reference: ready · empty · permission_denied · network_error
 */
export function IssuesPage() {
  return (
    <MovementListPage
      endpoint="issues"
      variant="issue"
      title="حواله خروج"
      emptyLabel="حواله خروجی ثبت نشده"
      emptyDescription="حواله جدید را از فرم بالا برای یک کالا و انبار ثبت کنید."
    />
  );
}
